import React, { useEffect } from "react";

export default function APInbox() {
   useEffect(() => {
      document.title = "Instruire Auto | Inbox";
   }, []);

   return (
      <main className="main">
         <section className="adminOther">
            <div className="adminOther__hero">
               <div className="adminOther__heroText">
                  <p className="adminOther__eyebrow">Admin</p>
                  <h1 className="adminOther__title">Inbox</h1>
                  <p className="adminOther__subtitle">
                     Mesajele și notificările platformei vor apărea aici.
                  </p>
               </div>
            </div>
         </section>
      </main>
   );
}
